/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PerformanceServiceQualitySplit } from "./PerformanceServiceQualitySplit";
import {
  PerformanceServiceQualitySplitFromJSON,
  PerformanceServiceQualitySplitFromJSONTyped,
  PerformanceServiceQualitySplitToJSON,
  PerformanceServiceQualitySplitToJSONTyped,
} from "./PerformanceServiceQualitySplit";
import type { PerformanceTransitSpread } from "./PerformanceTransitSpread";
import {
  PerformanceTransitSpreadFromJSON,
  PerformanceTransitSpreadFromJSONTyped,
  PerformanceTransitSpreadToJSON,
  PerformanceTransitSpreadToJSONTyped,
} from "./PerformanceTransitSpread";

/**
 * Measured against the window the carrier quoted on the shipment we
 * booked, which makes it an accuracy measure rather than a speed one: a
 * slow carrier that quotes honestly scores well, and a fast carrier that
 * over-promises scores badly. Nothing here compares them to anyone else.
 *
 * Undelivered shipments and shipments with no recorded quoted window are
 * excluded, never counted as on time.
 *
 * @export
 * @interface PerformanceServiceQuality
 */
export interface PerformanceServiceQuality {
  /**
   * Share delivered after the last day of their own quoted window.
   * Delivering on the last quoted day is on time. Absent when no
   * shipment in the period had both a window and a delivery.
   *
   * @type {number}
   * @memberof PerformanceServiceQuality
   */
  beyondWindowRate?: number;
  /**
   *
   * @type {PerformanceTransitSpread}
   * @memberof PerformanceServiceQuality
   */
  daysBeyondEarliest: PerformanceTransitSpread;
  /**
   *
   * @type {Array<PerformanceServiceQualitySplit>}
   * @memberof PerformanceServiceQuality
   */
  byService: Array<PerformanceServiceQualitySplit>;
  /**
   *
   * @type {Array<PerformanceServiceQualitySplit>}
   * @memberof PerformanceServiceQuality
   */
  byDeliveryLocationType: Array<PerformanceServiceQualitySplit>;
}

/**
 * Check if a given object implements the PerformanceServiceQuality interface.
 */
export function instanceOfPerformanceServiceQuality(
  value: object,
): value is PerformanceServiceQuality {
  if (
    !("daysBeyondEarliest" in value) ||
    value["daysBeyondEarliest"] === undefined
  )
    return false;
  if (!("byService" in value) || value["byService"] === undefined) return false;
  if (
    !("byDeliveryLocationType" in value) ||
    value["byDeliveryLocationType"] === undefined
  )
    return false;
  return true;
}

export function PerformanceServiceQualityFromJSON(
  json: any,
): PerformanceServiceQuality {
  return PerformanceServiceQualityFromJSONTyped(json, false);
}

export function PerformanceServiceQualityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceServiceQuality {
  if (json == null) {
    return json;
  }
  return {
    beyondWindowRate:
      json["beyondWindowRate"] == null ? undefined : json["beyondWindowRate"],
    daysBeyondEarliest: PerformanceTransitSpreadFromJSON(
      json["daysBeyondEarliest"],
    ),
    byService: (json["byService"] as Array<any>).map(
      PerformanceServiceQualitySplitFromJSON,
    ),
    byDeliveryLocationType: (json["byDeliveryLocationType"] as Array<any>).map(
      PerformanceServiceQualitySplitFromJSON,
    ),
  };
}

export function PerformanceServiceQualityToJSON(
  json: any,
): PerformanceServiceQuality {
  return PerformanceServiceQualityToJSONTyped(json, false);
}

export function PerformanceServiceQualityToJSONTyped(
  value?: PerformanceServiceQuality | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    beyondWindowRate: value["beyondWindowRate"],
    daysBeyondEarliest: PerformanceTransitSpreadToJSON(
      value["daysBeyondEarliest"],
    ),
    byService: (value["byService"] as Array<any>).map(
      PerformanceServiceQualitySplitToJSON,
    ),
    byDeliveryLocationType: (value["byDeliveryLocationType"] as Array<any>).map(
      PerformanceServiceQualitySplitToJSON,
    ),
  };
}
